<BI-grid-layout [cols]="['100%']">
    <BI-grid-layout-item [row]="1" [col]="1">
        <div class="titles">
            <h4>{{"Area Page" | translate}}</h4>
        </div>
    </BI-grid-layout-item>
    <BI-grid-layout-item [row]="2" [col]="1">
    <div class="container p-0">
        <div class="main-container">
            <div class="row">
                <ng-container *ngFor="let res of subModules; let i=index">
                    <div class="col-md-6 mb-2" *ngIf="res.text !=='Area Page'">
                        <div class="accordion" id="accordion">
                            <!-- occordion item -->
                            <div class="accordion-item">
                                <div class="accordion-header mt-0" id="BannerHeading">
                                    <button *ngIf="res.children" class="accordion-button border-bottom border-secondary"
                                        type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + i"
                                        aria-expanded="true" aria-controls="collapseOne">
                                        <h5 class="title">{{res.text | translate}}</h5>
                                        <hr>
                                    </button>
                                </div>
                                <div *ngIf="res.children" [id]="'collapse' + i"
                                    class="accordion-collapse px-3 collapse show" aria-labelledby="headingOne"
                                    data-bs-parent="#accordion">
                                    <kendo-treeview [nodes]="res.children" textField="text"
                                        kendoTreeViewHierarchyBinding childrenField="children" kendoTreeViewExpandable
                                        (selectionChange)="onSelectionChange($event)">
                                        <ng-template kendoTreeViewNodeTemplate let-dataItem>
                                            {{ dataItem.text | translate}}
                                        </ng-template>
                                    </kendo-treeview>
                                </div>
                                <div class="oneTitle" *ngIf="!res.children" (click)="navigateToPage(res.path)">
                                    {{res.text | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</BI-grid-layout-item>
</BI-grid-layout>